import React from 'react'
import { Box, Button } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { useState } from 'react'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData } from '../../../../../store/reports/reports_action'
import { connect } from 'react-redux'
import { lrStatusView, reportView, transType, urls } from '../../../../common/constants'
import { useEffect } from 'react'
import moment from 'moment/moment'
import { navigation3, appendToUrl, diffInMonths, focusElemnt, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import * as urlValue from '../../oldReportsUrls'
import { updateAlert, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { ownBookingDetailedColumns, ownBookingDetailedColumnsForBoth, ownBookingDetailedColumnsFormattedLRNO, ownBookingDetailedColumnsRemoveGST, ownBookingSummaryColumn } from '../BookingConstants'
import { globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { GetRequest } from '../../../../common/api'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { downloadPDF } from '../../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../../common/loginDecode'

const RefundReport = (props) => {
  const {
    data: { reports },
    getOwnBookingFilterData,
    getCargoSettingFilterData,
    updateAlert,
    updateAlertError,
  } = props
  const setLoader = useSetAtom(globalLoaderAtom)
  const { ownBookingDropData } = reports
  const [clickButton, setClickButton] = useState('')
  const [manageColumn, setManageColumn] = useState([])

  const [selCompany, setSelCompany] = useState('')
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))

  const [sourceCity, setSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])

  const [sourceBranch, setSourceBranch] = useState('')
  const [sourceBranchData, setSourceBranchData] = useState([])

  const [sourceBranchUser, setSourceBranchUser] = useState('')
  const [sourceBranchUserData, setSourceBranchUserData] = useState([])

  const [destinationCity, setDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [destinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchdata, setSelDestinationBranchdata] = useState([])

  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [transactionType, setTransactionType] = useState(transType?.[0])
  const [selReportView, setSelReportView] = useState(reportView?.[1])
  const [status, setStatus] = useState(lrStatusView?.[0])
  const [checkCrossinglr, setCheckCrossinglr] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const reportName = 'Refund Report'
  
  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
  const RefundReportPortrait = companySettings?.RefundReportPortrait || 0
  const UseToPayAsCOD = companySettings?.UseToPayAsCOD

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    loginData.strCityName = searchParams.get('CTN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }

  const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, strCityName, IsBranchAdmin, strBranchName, strUserName, IsMTPLAdmin } = loginData

  const headerData = {
    selCompany: strCompanyName || '',
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    sourceCity: sourceCity?.SourceCityName || '',
    sourceBranch: sourceBranch?.SourceBranchName || '',
    sourceBranchUser: sourceBranchUser?.UserBooked || '',
    destinationCity: destinationCity?.DestCityName || '',
    destinationBranch: destinationBranch?.DestBranchName || '',
    paymentType: paymentType?.name || '',
    transactionType: transactionType?.TransType || '',
    selReportView: selReportView?.ReportView || '',
    dataType: 'entry',
  }
  const criteriaHeaders = [
    { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
    { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
    { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
    { field: 'sourceBranchUser', header: 'Source Branch User', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'transactionType', header: 'TransactionType', textAlign: 'left' },
    { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
  ]
  const updatedSummaryCol = ownBookingSummaryColumn(UseToPayAsCOD, intCompanyID)
  const refundDetailedColumns = UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? ownBookingDetailedColumns(intCompanyID) : UseFormattedLRinReports === 2 ? ownBookingDetailedColumnsFormattedLRNO(intCompanyID) : ownBookingDetailedColumnsForBoth(intCompanyID)
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSourceCity(' ')
    setSourceBranch(' ')
    setSourceBranchUser(' ')
    setDestinationCity(' ')
    setSelDestinationBranch(' ')
    setPaymentType([paymentModesWithAll?.[0]])
    setTransactionType(transType?.[0])
    setSelReportView(reportView?.[1])
    setStatus(lrStatusView?.[0])
    setCheckCrossinglr(false)
  }
  const handleGoClick = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setClickButton('Go')
      const obj = {
        CompanyID: intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        FranchCompID: 0,
      }
      getOwnBookingFilterData(obj)
    }
  }
  const formatData = (response, type) => {
    if (!response?.Data) return [];

    const headers =
      type === 'Detailed'
        ? manageColumn.filter((obj) => obj.isSelected)
        : updatedSummaryCol;
    if (!headers?.length) return [];
    if (type === 'Detailed') {
      const raw = response.Data.Table ?? [];
      if (raw.length === 0) return [];

      let filtered = raw;

      if (transactionType?.TransId === 1) {
        filtered = raw.filter(r => r.IsRefund == 0);
      } else if (transactionType?.TransId === 2) {
        filtered = raw.filter(r => r.IsRefund == 1);
      }

      const grouped = {};
      filtered.forEach((val) => {
        const key = `${val.IsRefund}-${val.PaymentMode}`;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(val);
      });

      const transform = (list) =>
        list.map((val, i) => ({
          ...val,
          srNo: i + 1,
          dataType: 'entry',
          BookingDateTime: moment(val.BookingDateTime).format('DD-MMM-YY HH:mm'),
          CollDate: val.CollDate ? moment(val.CollDate).format('DD-MMM-YY HH:mm') : '',
          'LRNO^^ManualLRNo': `${val.LRNO}\n${val.ManualLRNo}`,
          'FormattedLRNO^^ManualLRNo': `${val.FormattedLRNO}\n${val.ManualLRNo}`,
          'SourceCityName^^SourceBranchName': `${val.SourceCityName}\n${val.SourceBranchName}`,
          'DestCityName^^DestBranchName': `${val.DestCityName}\n${val.DestBranchName}`,
          'BookingDateTime^^UserBooked': `${moment(val.BookingDateTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
          'Sender^^SenderGSTN': `${val.Sender}\n${val.SenderGSTN}`,
          'SenderMobileNo^^SenderEmailID': `${val.SenderMobileNo}\n${val.SenderEmailID}`,
          'RecName^^RecGSTN': `${val.RecName}\n${val.RecGSTN}`,
          'RecMobileNo^^ReceiverEmailID': `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
          'ConsignmentType^^Quantity': `${val.ConsignmentType}\n${val.Quantity}`,
          BookedResponse: val.BookedResponse ? JSON.parse(val.BookedResponse)?.TransID : '',
          DeliveredResponse: val.DeliveredResponse ? JSON.parse(val.DeliveredResponse)?.TransID : '',
          'CollDate^^UserName': val.CollDate ? `${moment(val.CollDate).format('DD-MMM-YY HH:mm')}\n${val.UserName}` : '',
        }));
      
      const summarize = (list) =>
        list.reduce((acc, val) => {
          acc.Quantity += +val.Quantity || 0;
          acc.Freight += +val.Freight || 0;
          acc.CartageAmount += +val.CartageAmount || 0;
          acc.HamaliCharges += +val.HamaliCharges || 0;
          acc.DocumentCharges += +val.DocumentCharges || 0;
          acc.Valuation += +val.Valuation || 0;
          acc.OtherCharges += +val.OtherCharges || 0;
          acc.OperatorHamaliChg += +val.OperatorHamaliChg || 0;
          acc.BookingGST += +val.BookingGST || 0;
          acc.NetAmount += +val.NetAmount || 0;
          return acc;
        }, {
          Quantity: 0,
          Freight: 0,
          CartageAmount: 0,
          HamaliCharges: 0,
          DocumentCharges: 0,
          Valuation: 0,
          OtherCharges: 0,
          OperatorHamaliChg: 0,
          BookingGST: 0,
          NetAmount: 0,
        });

      const finalData = [];

      const grandTotal = { ...summarize([]) };

      const lengths = divideInNIntegers(headers.length, 3);

      let index = 0;
      const pickedHeaders = [];

      lengths.forEach((span) => {
        pickedHeaders.push(headers[index]?.field);
        index += span;
      });

      const qtyIndex = headers.findIndex(
        (h) => h.field === 'ConsignmentType^^Quantity'
      );

      Object.entries(grouped).forEach(([key, list]) => {
        const [isRefund, paymentMode] = key.split('-');

        const transformed = transform(list);
        const summary = summarize(transformed);

        Object.keys(grandTotal).forEach(k => {
          grandTotal[k] += summary[k] || 0;
        });

        finalData.push({
          colSpan: Object.fromEntries(
            pickedHeaders.map((key, i) => [key, lengths[i] || 1])
          ),
          align: {
            [pickedHeaders[0]]: 'left',
            [pickedHeaders[1]]: 'center',
            [pickedHeaders[2]]: 'right',
          },
          [pickedHeaders[0]]: `Source City : ${sourceCity?.SourceCityName}`,
          [pickedHeaders[1]]: `Destination City : ${destinationCity?.DestCityName}`,
          [pickedHeaders[2]]: `Trans: ${isRefund === "0" ? "Booked" : "Refund"} | Payment Mode: ${paymentMode}`,
          dataType: 'subHeader',
          totalSubKey:3,
        });

        finalData.push(...transformed);

        finalData.push({
          ...summary,
          'ConsignmentType^^Quantity': summary.Quantity,
          colSpan: {
            [pickedHeaders[0]]: qtyIndex > 0 ? qtyIndex : 2,
          },
          [pickedHeaders[0]]: `Total: Src.City ${sourceCity?.SourceCityName} / Dest.City ${destinationCity?.DestCityName}`,
          dataType: 'total',
          align: { [pickedHeaders[0]]: 'right' },
        });
      });

      if (Object.keys(grouped).length > 1) {
        finalData.push({
          ...grandTotal,
          'ConsignmentType^^Quantity': grandTotal.Quantity,
          colSpan: {
            [pickedHeaders[0]]: qtyIndex > 0 ? qtyIndex : 2,
          },
          [pickedHeaders[0]]: `Net Total: Src.City All Cities / Dest.City All Cities`,
          dataType: 'total',
        });
      }

      return finalData;
    }

    if (type === 'Summary') {
      const raw = response.Data.Table1 ?? [];
      if (raw.length === 0) return [];

      const data = raw.map((v, i) => ({
        ...v,
        srNo: i + 1,
        dataType: 'entry',
      }));

      const totals = data.reduce((t, v) => {
        if (v.dataType === 'total') return t;

        Object.keys(t).forEach(k => {
          t[k] += +v[k] || 0;
        });

        return t;
      }, {
        LRCount: 0,
        ItemUnits: 0,
        Freight: 0,
        CartageAmount: 0,
        HamaliCharges: 0,
        DocumentCharges: 0,
        Valuation: 0,
        OtherCharges: 0,
        OperatorHamaliChg: 0,
        BookingGST: 0,
        Amount: 0,
        RefundAmt: 0,
        NetAmount: 0
      });

      return [
        ...data,
        {
          ...totals,
          srNo: 'Grand Total',
          dataType: 'total',
          colSpan: { [headers[0].field]: Math.min(2, headers.length) },
          align: { [headers[0].field]: 'center' },
        }
      ];
    }

    return [];
  };
  const handleClick1 = (isPdf = false) => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = sourceCity?.SourceCityID === 0 || sourceBranch?.SourceBranchID === 0 || sourceBranchUser?.UserID === 0 || destinationCity?.DestCityID === 0 || destinationBranch?.DestBranchID === 0;

    if (sourceCity == "" || sourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select Source City' });
    } else if (sourceBranch == "" || sourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Source Branch' });
    } else if (sourceBranchUser == "" || sourceBranchUser == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch User' });
    } else if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' });
    } else if (!isAllSelected && diffDays > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' });
    } else {
      setLoader(true);

      const object = {
        CompanyID: intCompanyID,
        SourceCityID: sourceCity?.SourceCityID || 0,
        SourceBranchID: sourceBranch?.SourceBranchID || 0,
        DateFrom: moment(fromDate).format('YYYY-MM-DD'),
        DateTo: moment(toDate).format('YYYY-MM-DD'),
        UserID: sourceBranchUser?.UserID || 0,
        DestCityID: destinationCity?.DestCityID || 0,
        DestBranchID: destinationBranch?.DestBranchID || 0,
        PaymentTypeIDs: paymentType.typeId || 0,
        Mode: transType[2]?.TransId || 0,
        StatusCode: 0,
        IsCrossingCity: checkCrossinglr ? 1 : 0,
        LoggedInUser: intUserID,
        AllowViewAllReport: 1,
      };
      GetRequest(urls.getOwnBookingReportData, object)
        .then((res) => {
          setLoader(false);
          if (res?.status !== 'Success' || !res?.Data?.Table?.length) {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
            return
          }
          if (res.status === 'Success') {
            const updatedData = {
              ...res,
              Data: {
                ...res.Data,
                Table1: res.Data.Table1.map((item,index) => ({
                  ...item,
                  srNo:index+1,
                  PayType:
                    UseToPayAsCOD === 1 && item.PaymentTypeID === 2
                      ? "COD"
                      : item.PaymentTypeID === 7
                        ? "COD(MANUAL)"
                        : item.PayType
                })),
                Table: res.Data.Table.map(item => ({
                  ...item,
                  PayType:
                    UseToPayAsCOD === 1 && item.PaymentTypeID === 2
                      ? "COD"
                      : item.PaymentTypeID === 7
                        ? "COD(MANUAL)"
                        : item.PayType
                })),
              }
            };

            const reportData = formatData(updatedData, selReportView?.ReportView);

            if (reportData.length > 0) {

              let mainHeader = [];

              if (selReportView?.ReportView === 'Detailed') {
                mainHeader = manageColumn
                  .filter(obj => obj.isSelected)
                  .map(val => ({
                    ...val,
                    align: val.headerSx.textAlign,
                    export: val.exportHead,
                    weight: 80,
                    dataType: 'header'
                  }));
              } else {
                mainHeader = updatedSummaryCol.map(val => ({
                  ...val,
                  align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                  export: val.exportHead,
                  weight: 80,
                  dataType: 'header'
                }));
              }
              let reportPayload = {}
              if (selReportView?.ReportView === 'Detailed') {
                mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
                  ...val,
                  align: val.headerSx.textAlign,
                  export: val.exportHead,
                  weight: 80
                }))
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [headerData],
                  tableData: reportData,
                  mainHeader: mainHeader,
                  isShowManageColumn: true,
                  manageColumnID: 'manageColIdValueeV2',
                  colSpanMarker: "STATUS",
                  hideHeader: false,
                  showColumnBorders: true,
                  totalSubKey:3,
                  serialNokey : 'srNo'
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [headerData],
                    tableData: reportData,
                    visibleColumns: mainHeader,
                    loginData,
                    showColumnBorders:true,
                    hideHeader: false
                  })
                  return
                }
              } else {
                mainHeader = updatedSummaryCol.map((val) => ({
                  ...val,
                  align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                  export: val.exportHead,
                  weight: 80
                }))
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [headerData],
                  tableData: reportData,
                  mainHeader: mainHeader,
                  hideHeader: false,
                  showColumnBorders: true,
                  serialNokey: 'srNo'
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [headerData],
                    tableData: reportData,
                    visibleColumns: mainHeader,
                    loginData,
                    showColumnBorders: true,
                    hideHeader: false
                  })
                  return
                }
              }
              const rid = Date.now().toString();

              window.generatedReports = window.generatedReports || {};
              window.generatedReports[rid] = reportPayload;

              window.open(`/view-report?rid=${rid}`, "_blank");
            }

          } else {
            updateAlert({ show: true, msg: res.ErrMessage });
          }
        });
    }
  };
  const handleClick2 = () => {
    if (transactionType?.TransId === 1) {
      updateAlert({ show: true, msg: 'Booked Trans. Not Allowed' })
    } else if (destinationBranch.DestBranchID != 0) {
      updateAlert({ show: true, msg: `Please Select All Destination Branch and Try Again.` })
    } else if (diffInMonths(fromDate, toDate) !== 0) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      let url = urlValue.RefundReport
      let urlData = urlValue.RefundReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.intCompanyID = intCompanyID
      urlData.intBranchID = sourceBranch.SourceBranchID || 0
      urlData.LoginBranchid = intBranchID
      urlData.intUserID = sourceBranchUser?.UserID || 0
      urlData.dtfromDate = fromDate.format('DD-MMM-YYYY')
      urlData.dtToDate = toDate.format('DD-MMM-YYYY')
      urlData.selectedBranchName = sourceBranch.SourceBranchName
      urlData.UserName = sourceBranchUser?.UserBooked
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  useEffect(() => {
    focusElemnt("fromDate")
  }, [])

  useEffect(() => {
    if (!isEmpty(intUserID)) {
      const obj = {
        intCompanyID: intCompanyID,
        intBranchID: intBranchID,
        intUserID: intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [intUserID])

  useEffect(() => {
    if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
      setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
    }
  }, [roleRightsData])

  useEffect(() => {
    if (ownBookingDropData.status === 'Success') {
      if (ownBookingDropData?.Data?.Table?.length >= 1) {
        const SourceCity = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({ SourceCityName: val.SourceCityName, SourceCityID: val.SourceCityID }))
          ),
        ]
        const SourceBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({ SourceBranchName: val.SourceBranchName, SourceBranchID: val.SourceBranchID, SourceCityID: val.SourceCityID }))
          ),
        ]
        const SourceBranchUser = [
          ...new Set(ownBookingDropData?.Data?.Table?.map((val) => ({ UserBooked: val.UserBooked, UserID: val.UserID, SourceBranchID: val.SourceBranchID }))),
        ]
        const DestinationCity = [
          ...new Set(ownBookingDropData?.Data?.Table?.map((val) => ({ DestCityName: val.DestCityName, DestCityID: val.DestCityID, SourceCityID: val.SourceCityID }))),
        ]
        const DestinationBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({ DestBranchName: val.DestBranchName, DestBranchID: val.DestBranchID, DestCityID: val.DestCityID }))
          ),
        ]

        if (disableBtn) {
          setSourceCity({ SourceCityName: strCityName, SourceCityID: intBranchCityID })
          if (disableBtn && AllowViewAllBranchOfCityReport == 1) {
            const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === intBranchID)
            const selectedUser = SourceBranchUser?.filter((val) => val.UserID === intUserID)
            if (selectedBranch?.length > 0) {
              setSourceBranch(selectedBranch?.[0])
            } else {
              setSourceBranch({ SourceBranchName: "All Branch", SourceBranchID: 0 })
            }
            if (selectedUser?.length > 0) {
              setSourceBranchUser(selectedUser?.[0])
            } else {
              setSourceBranchUser({ UserBooked: "All Branch User", UserID: 0 })
            }
          } else {
            setSourceBranch({ SourceBranchName: strBranchName, SourceBranchID: intBranchID })
            setSourceBranchUser({ UserBooked: strUserName, UserID: intUserID })
          }
        } else {
          const selectedCity = SourceCity?.filter((val) => val.SourceCityID === intBranchCityID)
          const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === intBranchID)
          const selectedUser = SourceBranchUser?.filter((val) => val.UserID === intUserID)
          if (selectedCity?.length > 0) {
            setSourceCity(selectedCity?.[0])
          } else {
            setSourceCity({ SourceCityName: "All Cities", SourceCityID: 0 })
          }
          if (selectedBranch?.length > 0) {
            setSourceBranch(selectedBranch?.[0])
          } else {
            setSourceBranch({ SourceBranchName: "All Branch", SourceBranchID: 0 })
          }
          if (selectedUser?.length > 0) {
            setSourceBranchUser(selectedUser?.[0])
          } else {
            setSourceBranchUser({ UserBooked: "All Branch User", UserID: 0 })
          }
        }
        setSourceCityData([{ SourceCityName: "All Cities", SourceCityID: 0 }, ...SourceCity])
        setSourceBranchData([{ SourceBranchName: "All Branch", SourceBranchID: 0 }, ...SourceBranch])
        setSourceBranchUserData([{ UserBooked: "All Branch User", UserID: 0 }, ...SourceBranchUser])
        setDestinationCityData([{ DestCityName: 'All Cities', DestCityID: 0 }, ...DestinationCity])
        setSelDestinationBranchdata([{ DestBranchName: 'All Branch', DestBranchID: 0 }, ...DestinationBranch])
        setDestinationCity({ DestCityName: "All Cities", DestCityID: 0 })
        setSelDestinationBranch({ DestBranchName: "All Branch", DestBranchID: 0 })
      } else {
        setSourceCityData([])
      }
    }
  }, [ownBookingDropData])

  useEffect(() => {
    try {
      let finalCols =
        DefaultCurrencyID === 2
          ? ownBookingDetailedColumnsRemoveGST(intCompanyID)
          : refundDetailedColumns;

      if (RefundReportPortrait === 1) {
        finalCols = finalCols.filter((item) => item.isMandatory);
      }

      finalCols = finalCols.map((col) => {
        let updatedCol = {
          ...col,
          weight: 40,
        };

        if (col.field === "Valuation") {
          updatedCol = {
            ...updatedCol,
            header: DefaultCurrencyID === 2 ? "Insu.\nChrg." : "Val.\nChrg.",
            exportHead: DefaultCurrencyID === 2 ? "Insu.\nChrg." : "Val.\nChrg.",
          };
        }

        return updatedCol;
      });

      setManageColumn(finalCols);
    } catch (error) {
      console.error(error);

      let fallbackCols =
        DefaultCurrencyID === 2
          ? ownBookingDetailedColumnsRemoveGST(intCompanyID)
          : refundDetailedColumns;

      if (RefundReportPortrait === 1) {
        fallbackCols = fallbackCols.filter((item) => item.isMandatory);
      }

      fallbackCols = fallbackCols.map((col) => ({
        ...col,
        weight: 40,
      }));

      setManageColumn(fallbackCols);
    }
  }, [DefaultCurrencyID, RefundReportPortrait]);

  const selectedSourceCity = (obj) => {
    setSourceCity(obj)
    setSourceBranch(removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0])
  }
  const selectedSourceBranch = (obj) => {
    setSourceBranch(obj)
    setSourceBranchUser(removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter((val) => val?.SourceBranchID === obj?.SourceBranchID || obj?.SourceBranchID === 0 || val?.UserID === 0)?.[0])
  }
  const selectedDestCity = (obj) => {
    setDestinationCity(obj)
    setSelDestinationBranch(removeDuplicatesFromArray(destinationBranchdata, "DestBranchID").filter((val) => val.DestCityID === obj?.DestCityID || obj?.DestCityID === 0 || val.DestBranchID === 0)?.[0])
  }
  return (
    <>
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
        {!isFromUrl && <><Item sx={sx.itemsxGrow}>
          <DropDownOA
            id="selectCompnay"
            label="Selected Company"
            defaultvalue={strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="100%"
          />
        </Item>
          <Item sx={sx.itemsx}>
            <Button variant="contained" className="go click-button" disabled={true}>
              GO
            </Button>
          </Item>
        </>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            value={fromDate}
            name={'from_booking_date'}
            dateDiff={365}
            label={lb.fromBookingDate}
            id={'fromDate'}
            nextId={'toDate'}
            prevId={'fromDate'}
            dateChange={(date) => { setFromDate(date); focusElemnt('toDate') }}
            width={isFromUrl ? '100%' : '170px'}
          />
        </Item>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              value={toDate}
              name={'to_booking_date'}
              label={lb.toBookingDate}
              id={'toDate'}
              nextId={'OwnBookingGoBtn'}
              prevId={'fromDate'}
              dateChange={(date) => { setToDate(date); focusElemnt('OwnBookingGoBtn') }}
              width={isFromUrl ? '100%' : '170px'}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              id="OwnBookingGoBtn"
              variant="contained"
              className="go click-button"
              onClick={handleGoClick}
              onKeyDown={(e) => navigation3(e, 'sourceCity', 'fromDate', handleGoClick)}
            >
              GO
            </Button>
          </Item>
        </Box>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Source City"
            id="sourceCity"
            nextId={'sourceBranch'}
            prevId={'OwnBookingGoBtn'}
            data={removeDuplicatesFromArray(sourceCityData, 'SourceCityID') || []}
            defaultvalue={sourceCity?.SourceCityName || sourceCity}
            dataKey={`SourceCityName`}
            idKey={`SourceCityID`}
            disabled={disableBtn}
            onSelect={(obj) => selectedSourceCity(obj)}
            width={isFromUrl ? '100%' : '170px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Source Branch"
            id="sourceBranch"
            nextId={'sourceBranchUser'}
            prevId={'sourceCity'}
            disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
            data={
              removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID').filter(
                (val) => val.SourceCityID === sourceCity?.SourceCityID || sourceCity?.SourceCityID === 0 || val.SourceBranchID === 0
              ) || []
            }
            defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
            dataKey={`SourceBranchName`}
            idKey={`SourceBranchID`}
            onSelect={(val) => selectedSourceBranch(val)}
            width={isFromUrl ? '100%' : '170px'}
            listWidth={'250px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Source Branch User"
            id="sourceBranchUser"
            nextId={'destinationCity'}
            prevId={'sourceBranch'}
            disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
            defaultvalue={sourceBranchUser?.UserBooked || sourceBranchUser}
            data={
              removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter(
                (val) => val?.SourceBranchID === sourceBranch?.SourceBranchID || sourceBranch?.SourceBranchID === 0 || val?.UserID === 0
              ) || []
            }
            dataKey={`UserBooked`}
            idKey={`UserID`}
            onSelect={(val) => {
              setSourceBranchUser(val)
            }}
            width={isFromUrl ? '100%' : '170px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Destination City"
            id="destinationCity"
            nextId={'destinationBranch'}
            prevId={'sourceBranchUser'}
            defaultvalue={destinationCity?.DestCityName || destinationCity}
            data={
              removeDuplicatesFromArray(destinationCityData, 'DestCityID').filter(
                (val) => val.DestCityID !== sourceCity?.SourceCityID || val.DestCityID === 0
              ) || []
            }
            dataKey={`DestCityName`}
            idKey={`DestCityID`}
            onSelect={(obj) => selectedDestCity(obj)}
            width={isFromUrl ? '100%' : '170px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Destination Branch"
            id="destinationBranch"
            nextId={'paymentType'}
            prevId={'destinationCity'}
            defaultvalue={destinationBranch?.DestBranchName || destinationBranch}
            data={
              removeDuplicatesFromArray(destinationBranchdata, 'DestBranchID').filter(
                (val) => val.DestCityID === destinationCity?.DestCityID || destinationCity?.DestCityID === 0 || val.DestBranchID === 0
              ) || []
            }
            dataKey={`DestBranchName`}
            idKey={`DestBranchID`}
            onSelect={(obj) => {
              setSelDestinationBranch(obj)
            }}
            width={isFromUrl ? '100%' : '170px'}
            listWidth={'250px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label={'Payment Type'}
            data={
              (paymentModesWithAll || []).map((item) => {
                if (UseToPayAsCOD === 1) {
                  if (item.typeId === 2) {
                    return { ...item, name: 'COD' };
                  }
                  if (item.typeId === 7) {
                    return { ...item, name: 'COD Manual' };
                  }
                  if (item.typeId === 9) {
                    return { ...item, name: 'COD DDDV' };
                  }
                  if (item.typeId === 4) {
                    return null;
                  }
                }
                return item;
              }).filter(Boolean)
            }
            id="paymentType"
            nextId={'TransactionType'}
            prevId={'destinationBranch'}
            defaultvalue={paymentType?.name || ''}
            width="100%"
            searchPlaceholder={`Search By Payment Type`}
            tabIndex="2"
            dataKey={`name`}
            idKey={`typeId`}
            onSelect={(val) => {
              setPaymentType(val)
            }}
          />
        </Item>
        {!isFromUrl && <Item sx={sx.itemsx}>
          <DropDownOA
            label="Txn.Type"
            id="TransactionType"
            nextId={'ReportView'}
            prevId={'paymentType'}
            defaultvalue={transType[2]?.TransType || ''}
            data={transType}
            onSelect={(val) => {
              setTransactionType(val)
            }}
            dataKey={`TransType`}
            idKey={`TransId`}
            width="170px"
            disabled
          />
        </Item>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            id="ReportView"
            nextId={'LrStatus'}
            prevId={'TransactionType'}
            label="Report View"
            data={reportView}
            defaultvalue={selReportView?.ReportView || ''}
            dataKey={`ReportView`}
            onSelect={(val) => {
              setSelReportView(val)
            }}
            idKey={`ReportId`}
            width={isFromUrl ? '100%' : '170px'}
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.summaryCheck}>
            DOWNLOAD PDF
          </Button> :
          <>
            <Item
              sx={sx.itemsx}
              style={{ cursor: 'pointer' }}
              onKeyDown={(e) => {
                navigation3(e, 'fromDate', 'OwnChechBox', () => handleClick1())
              }}
            >
              <SplitButton
                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                prevID={id.summaryCheck}
                onClick1={handleClick1}
                onClick2={handleClick2}
              />
            </Item>
            <Item sx={sx.itemsx} className="flex-center-all" onClick={reset}>
              <RefreshSvg />
            </Item></>}
      </Box>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData, updateAlert, updateAlertError, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(RefundReport)
